import { Length, MaxString, ModelBase, NormalLength, Property, Required, ShortLength } from '@skylab-shared/core';
import { head } from '@skylab-shared/utils';
import { DiscountKind } from '../common/discount-kind';
import { DocumentItemAmountsSource } from './document-item-amounts-source';

export class DocumentItemModel extends ModelBase {
    @Property({nullable: true})
    public readonly adjusted: boolean;

    @Property({nullable: true})
    public readonly amountsSource: DocumentItemAmountsSource;

    @Property()
    public readonly id?: number;

    @Property(String, {nullable: true})
    @Length({ max: ShortLength }, 'data-model.document-item.validation.cn-code.length')
    public cnCode: string | null;

    @Property(String, {nullable: true})
    @Length({ max: NormalLength }, 'data-model.document-item.validation.pkwiu.length')
    public pkwiu: string | null;

    @Property({ nullable: true })
    @Length({ max: ShortLength }, 'data-model.product.validation.bar-code.length')
    public barCode: string;

    @Property({ nullable: true })
    @Length({ max: ShortLength }, 'data-model.product.validation.symbol.length')
    public symbol: string;

    @Property(String, { nullable: true })
    @MaxString('data-model.document-item.validation.note.length')
    public note: string | null;

    @Property()
    public ordinalNumber: number;

    @Property()
    public discountValue: number;

    @Property()
    public discountKind: DiscountKind;

    @Property()
    public price_grossAfterDiscount: number;

    @Property()
    public price_grossBeforeDiscount: number;

    @Property()
    public price_netAfterDiscount: number;

    @Property()
    public price_netBeforeDiscount: number;

    @Property(Number, { nullable: true })
    public productId: number | null;

    @Property(String, { nullable: true })
    @Length({ max: 255 }, 'data-model.document-item.validation.name.length')
    @Required('data-model.document-item.validation.name.not-empty')
    public productName: string | null;

    @Property()
    public quantity: number;

    @Property()
    public unitId: number;

    @Property()
    public unitSymbol: string;

    //#region Value

    @Property()
    public value_grossAfterDiscount: number;

    @Property()
    public value_grossBeforeDiscount: number;

    @Property()
    public value_netAfterDiscount: number;

    @Property()
    public value_netBeforeDiscount: number;

    @Property()
    public value_vatAfterDiscount: number;

    @Property()
    public value_vatBeforeDiscount: number;

    @Property(Number, { nullable: true })
    public inventoryLevel?: number | null;
    //#endregion

    @Property()
    @Required('data-model.document-item.validation.vat-rate.required')
    public vatRateId: number;

    @Property()
    public jpkVatGroups: string[];

    public get jpkVatGroup(): string {
        return head(this.jpkVatGroups);
    }

    public set jpkVatGroup(value: string) {
        this.jpkVatGroups = value ? [value] : [];
    }
}
